/* __next_internal_client_entry_do_not_use__ Favorite auto */ import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import styled from "styled-components";
import { FavoriteTrackingEventsContext } from "@faire/retailer/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/components/Favorite/__internal__/FavoriteTrackingEventsContext";
import { SaveToBoard } from "@faire/retailer/features/RetailerBoards/Components/SaveToBoard";
import { SaveToBoardContext, SaveToBoardProvider } from "@faire/retailer/features/RetailerBoards/Context";
import { FavoriteTrackingEventsContextProviderBase } from "./__internal__/FavoriteTrackingEventsContextProviderBase";
var FavoriteBase = function(param) {
    var _param_data = param.data, productToken = _param_data.productToken, hide = _param_data.hide, bestImage = _param_data.bestImage, boardTokens = _param_data.boardTokens, brandToken = _param_data.brandToken;
    var saveToBoardContext = React.useContext(SaveToBoardContext);
    var _React_useContext = React.useContext(FavoriteTrackingEventsContext), recordHeartClickedEvent = _React_useContext.recordHeartClickedEvent, recordSaveToBoardSubmitEvent = _React_useContext.recordSaveToBoardSubmitEvent, recordRemoveFromBoardSubmitEvent = _React_useContext.recordRemoveFromBoardSubmitEvent;
    // There used to be a canSaveToBoard to control whether we should render this button
    // but it's truthy in discovery tiles, so we don't need to handle it here.
    if (hide) {
        return;
    }
    var _saveToBoardContext_trackOrigin;
    return /*#__PURE__*/ _jsx(StyledSaveToBoardContainer, {
        children: /*#__PURE__*/ _jsx(SaveToBoardProvider, {
            value: {
                trackOrigin: (_saveToBoardContext_trackOrigin = saveToBoardContext.trackOrigin) !== null && _saveToBoardContext_trackOrigin !== void 0 ? _saveToBoardContext_trackOrigin : "brand"
            },
            children: /*#__PURE__*/ _jsx(SaveToBoard, {
                "data-test-id": "favorite-button",
                productToken: productToken,
                productImage: bestImage,
                boardTokens: boardTokens,
                brandToken: brandToken,
                onHeartClicked: recordHeartClickedEvent,
                onSaveToBoard: recordSaveToBoardSubmitEvent,
                onRemoveFromBoard: recordRemoveFromBoardSubmitEvent
            }, "".concat(productToken, "-favorite"))
        })
    });
};
export var Favorite = function(param) {
    var data = param.data;
    return /*#__PURE__*/ _jsx(FavoriteTrackingEventsContextProviderBase, {
        data: data,
        children: /*#__PURE__*/ _jsx(FavoriteBase, {
            data: data
        })
    });
};
var StyledSaveToBoardContainer = styled.div.withConfig({
    componentId: "sc-be20980a-0"
})([
    "position:absolute;right:4px;z-index:3;top:4px;"
]);
